module.exports = __webpack_public_path__ + "media/images/sites/health/f-blog-b4c1d1d5a013b3381708cdeae63343da.jpg";